export default __webpack_public_path__ + "static/media/2_my_documents.8783b090.svg";